module.exports = __webpack_public_path__ + "static/media/konosuba.51527ecb.jpg";